import { z } from "zod";

export const statusSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type Status = z.infer<typeof statusSchema>;
